<template>
  <div>
    <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="uploadFn"
      :before-upload="beforeAvatarUpload">
      <img v-if="imageUrl" :src="imageUrl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon" color="red" />
      <!-- 进度条 -->
      <!-- <el-progress v-if="isShow" type="circle" :percentage="percentage" class="progress" /> -->
    </el-upload>
  </div>
</template>

<script>
// import axios from 'axios'
import { resources_insertApi } from '../../api/index'
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageUrl: '',
      percentage: 0,
      isShow: false
    }
  },
  watch: {
    url() {
      this.imageUrl = this.url
    }
  },
  created() {
    this.imageUrl = this.url
    // console.log('urlurl', this.url)
  },
  methods: {
    // 头像上传
    beforeAvatarUpload(file) {
      const fileType = ['image/jpeg', 'image/jpg', 'image/png']
      const isJPG = fileType.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpeg,jpg,png格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    async uploadFn(obj) {
      this.isShow = true
      const formData = new FormData()
      formData.append('resources[]', obj.file)
      // const res = await axios({
      //   method: 'PATCH',
      //   url: 'http://geek.itheima.net/v1_0/user/photo',
      //   data: formData,
      //   headers: {
      //     'Authorization': 'Bearer bedd5cc2-2b55-4055-92af-799ef26ea484'
      //   }
      // })
      const res = await resources_insertApi(
        formData
      )
      this.isShow = false
      this.imageUrl = res.data.data[0]

      this.$emit('imgUrlFn', this.imageUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
// 头像上传
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
